import {
  Component,
  forwardRef,
  Input,
  Output,
  EventEmitter,
  OnInit
} from '@angular/core'
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  FormsModule
} from '@angular/forms'
import { TranslateService, TranslatePipe } from '@ngx-translate/core'
import { SelectModule } from 'primeng/select'
import { MultiSelectModule } from 'primeng/multiselect'

@Component({
  selector: 'app-custom-select',
  templateUrl: './custom-select.component.html',
  styleUrls: ['./custom-select.component.scss'],
  standalone: true,
  imports: [FormsModule, TranslatePipe, SelectModule, MultiSelectModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomSelectComponent),
      multi: true
    }
  ]
})
export class CustomSelectComponent implements ControlValueAccessor, OnInit {
  @Input() items: any[] = []
  @Input() bindLabel = 'name'
  @Input() bindValue = 'id'
  @Input() placeholder = ''
  @Input() label = ''
  @Input() required = false
  @Input() multiple = false
  @Input() searchable = true
  @Input() styleClass = 'mt-3'

  @Output() clear = new EventEmitter<void>()
  @Output() open = new EventEmitter<void>()
  @Output() searchEvent = new EventEmitter<string>()
  @Output() changeEvent = new EventEmitter<any>()

  currentLanguage = localStorage.getItem('lang')
  value: any
  disabled = false

  onChange: (value: any) => void = () => {}
  onTouched: () => void = () => {}

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {
    this.translate.onLangChange.subscribe(
      (lang) => (this.currentLanguage = lang.lang)
    )
  }

  // Localized empty/no-results text (was NgSelectConfig.notFoundText).
  get notFoundText(): string {
    return this.currentLanguage === 'en' ? 'Items Not Found' : 'لا يوجد بيانات'
  }

  writeValue(value: any): void {
    this.value = value
  }
  registerOnChange(fn: any): void {
    this.onChange = fn
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn
  }
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled
  }

  handleChange(value: any): void {
    this.value = value
    this.onChange(value)
    this.onTouched()
  }

  // (onFilter) — emits the typed text so parents can fetch filtered options.
  onSearch(term: string): void {
    this.searchEvent.emit(term)
  }
  onValueChange(value: any): void {
    this.changeEvent.emit(value)
  }
  clearItems(): void {
    this.clear.emit()
  }
}
